// Avisos na tela (no canto, sem travar a página) no lugar do alert() do navegador, em todo o Portal.
// `avisar(texto)` pode ser chamado de qualquer lugar (componente, hook ou lib). O tom sai do texto: erro/falha/não
// foi possível/preencha… = vermelho; o resto = verde. Some sozinho (erro fica mais); texto longo fica até fechar.
// O <Avisos /> fica montado uma vez no App.
import { useEffect, useState } from 'react';

type Aviso = { id: number; texto: string; erro: boolean; fixo: boolean };
let seq = 0;
let lista: Aviso[] = [];
const ouvintes = new Set<(a: Aviso[]) => void>();
const emitir = () => ouvintes.forEach((f) => f(lista));
const ERRO = /\b(erro|falh|não foi possível|nao foi possivel|não deu|inválid|obrigatóri|preencha|informe|selecione|escolha|não pode|não encontrad|sem permiss|negad|limite)/i;

export function fecharAviso(id: number) { lista = lista.filter((a) => a.id !== id); emitir(); }

export function avisar(mensagem?: unknown): void {
  const texto = String(mensagem ?? '').trim();
  if (!texto) return;
  const a: Aviso = { id: ++seq, texto, erro: ERRO.test(texto), fixo: texto.length > 220 || texto.split('\n').length > 4 };
  lista = [...lista.slice(-4), a];
  emitir();
  if (!a.fixo) setTimeout(() => fecharAviso(a.id), a.erro ? 9000 : 5000);
}

export default function Avisos() {
  const [itens, setItens] = useState<Aviso[]>(lista);
  useEffect(() => { ouvintes.add(setItens); return () => { ouvintes.delete(setItens); }; }, []);
  if (!itens.length) return null;
  return (
    <div style={{ position: 'fixed', right: 16, bottom: 16, zIndex: 10000, display: 'flex', flexDirection: 'column', gap: 8, maxWidth: 'min(440px, calc(100vw - 32px))' }}>
      {itens.map((a) => (
        <div key={a.id} role={a.erro ? 'alert' : 'status'} style={{
          display: 'flex', gap: 10, alignItems: 'flex-start', padding: '10px 12px', borderRadius: 10, boxShadow: '0 6px 20px rgba(15,23,42,.18)',
          background: a.erro ? '#fef2f2' : '#f0fdf4', border: `1px solid ${a.erro ? '#fecaca' : '#bbf7d0'}`, borderLeft: `5px solid ${a.erro ? '#dc2626' : '#16a34a'}`,
          color: '#0f172a', fontSize: 14, lineHeight: 1.4,
        }}>
          <span aria-hidden>{a.erro ? '⚠️' : '✅'}</span>
          <div style={{ flex: 1, whiteSpace: 'pre-line', maxHeight: 260, overflowY: 'auto', wordBreak: 'break-word' }}>{a.texto}</div>
          <button onClick={() => fecharAviso(a.id)} aria-label="Fechar aviso" style={{ border: 0, background: 'none', cursor: 'pointer', color: '#64748b', fontSize: 16, lineHeight: 1 }}>✕</button>
        </div>
      ))}
    </div>
  );
}
